
import { motion } from "framer-motion";
import { Star } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

const TestimonialsUpdated = () => {
  const testimonials = [
    {
      name: "Filip Joker",
      text: "Usługa czyszczenia tapicerki bardzo dobrze wykonana, na duży plus kontakt z klientem. Polecam 👌",
      rating: 5,
    },
    {
      name: "Ela Flo",
      text: "Jestem bardzo zadowolona z kompleksowo wykonanej usługi przez pana Dawida. Usługa obejmowała pranie tapicerki, czyszczenie auta wewnątrz oraz zewnątrz. Auto jak nowe, serdecznie polecam!",
      rating: 5,
    },
    {
      name: "Wiktor Kolwicz",
      text: "Polecam! Skrupulatnie wykonana praca, wieloetapowo. Pan posiada wysokiej jakości sprzęty. Dobry kontakt. Dywan i fotel wyglądają jak nowe 🙂",
      rating: 5,
    },
    {
      name: "Piotr Garstecki",
      text: "Polecam. Dla mnie ważna była możliwość umycia auta u mnie w domu. Kontakt, dokładność i jakość usługi na wysokim poziomie.",
      rating: 5,
    },
    {
      name: "Joanna Paczocha",
      text: "Bardzo fachowa obsługa, świetny kontakt, elastyczne terminy. Tapicerka wygląda jak nowa, a była niemyta kilka dobrych lat. Polecam!",
      rating: 5,
    },
    {
      name: "Maciej Kubiak",
      text: "Z czystym sumieniem mogę polecić współpracę. Firma w sposób profesjonalny zajęła się wyczyszczeniem auta żony (Kia Picanto), gdzie przy małym dziecku to nie lada wyczyn. Auto odzyskało dawny blask, a współpraca z właścicielami to przykład dobrego zaangażowania. Jeżeli chcesz by Twoim autem zajęli się w sposób profesjonalny i oczekujesz, że jako klient będziesz na pierwszym miejscu - to dobrze trafiłeś!",
      rating: 5,
    },
  ];

  return (
    <section id="testimonials" className="section-spacing bg-garage-dark">
      <div className="container-spacing">
        <motion.h2 
          className="section-title text-center"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "0px 0px -100px 0px" }}
          transition={{ duration: 0.6 }}
        >
          Opinie klientów
        </motion.h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={testimonial.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "0px 0px -100px 0px" }}
              transition={{ duration: 0.5, delay: 0.1 * index }}
            >
              <Card className="bg-black border-white/20 hover:border-garage-blue transition-colors h-full shadow-lg hover:shadow-blue-900/20">
                <CardContent className="p-6">
                  <div className="flex mb-4">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <Star key={i} className="h-5 w-5 text-yellow-400 fill-current" />
                    ))}
                  </div>
                  <p className="text-gray-300 mb-4 italic leading-relaxed">"{testimonial.text}"</p>
                  <p className="text-garage-blue font-semibold">— {testimonial.name}</p>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsUpdated;
